/* eslint-disable react-hooks/exhaustive-deps */
import React, { Fragment, useEffect, useState } from "react";
import {
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Card,
  CardBody,
  Container,
} from "reactstrap";
import Breadcrumb from "../common/breadcrumb";
import { adminInstance } from "../../config/axios";
import { toast } from "react-toastify";
import { queryString } from "../../utils/queryString";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import Loader from "../loader/loader";

const CreateBanner = () => {
  const [data, setData] = useState({ title: "" });
  const [imageFile, setImageFile] = useState(null);
  const [errors, setErrors] = useState({ title: "", image: "" });
  const [laoder, setLoader] = useState(false);
  const { id } = queryString();
  const history = useHistory();

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "image") {
      const file = files[0];

      if (!file) return;

      const validTypes = ["image/jpeg", "image/jpg", "image/png", "image/webp"];

      const validExtensions = [".jpg", ".jpeg", ".png", ".webp"];
      const maxSize = 5 * 1024 * 1024;
      const REQUIRED_WIDTH = 1280;
      const REQUIRED_HEIGHT = 500;

      const fileTypeValid = validTypes.includes(file.type);
      const fileExtensionValid = validExtensions.some((ext) =>
        file.name.toLowerCase().endsWith(ext)
      );

      if (!fileTypeValid && !fileExtensionValid) {
        setErrors((prev) => ({
          ...prev,
          image: "Unsupported file type. Allowed: JPG, JPEG, PNG, WEBP.",
        }));
        setImageFile(null);
        return;
      }

      if (file.size > maxSize) {
        setErrors((prev) => ({
          ...prev,
          image: "File too large. Max size is 5MB.",
        }));
        setImageFile(null);
        return;
      }

      const img = new Image();
      img.src = URL.createObjectURL(file);

      img.onload = () => {
        if (img.width !== REQUIRED_WIDTH || img.height !== REQUIRED_HEIGHT) {
          setErrors((prev) => ({
            ...prev,
            image: `Image dimensions must be exactly ${REQUIRED_WIDTH} × ${REQUIRED_HEIGHT}px.`,
          }));
          setImageFile(null);
        } else {
          setErrors((prev) => ({ ...prev, image: "" }));
          setImageFile(file);
        }
        URL.revokeObjectURL(img.src);
      };

      img.onerror = () => {
        setErrors((prev) => ({
          ...prev,
          image: "Invalid image file.",
        }));
        setImageFile(null);
      };
    } else {
      setData({
        ...data,
        [name]: value,
      });

      if (!value.trim()) {
        setErrors((prev) => ({ ...prev, [name]: "This field is required." }));
      } else {
        setErrors((prev) => ({ ...prev, [name]: "" }));
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let hasError = false;

    if (!data.title.trim()) {
      setErrors((prev) => ({ ...prev, title: "Title is required." }));
      hasError = true;
    }

    if (!imageFile && !id) {
      setErrors((prev) => ({
        ...prev,
        image: "Please upload a valid Banner.",
      }));
      hasError = true;
    }

    if (hasError) return;

    const formData = new FormData();
    formData.append("title", data.title);
    if (imageFile instanceof File) {
      formData.append("image", imageFile);
    }

    setLoader(true);

    try {
      let response;

      if (id) {
        response = await adminInstance().put(
          `/api/admin/updateBanner/${id}`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
            timeout: 10 * 60 * 1000,
          }
        );
      } else {
        response = await adminInstance().post(
          "/api/admin/addBanner",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
            timeout: 10 * 60 * 1000,
          }
        );
      }

      const { code, msg } = response?.data;
      if (code === 200) {
        toast.success(msg, { toastId: "bannerUplaod" });
        setData({ title: "" });
        setImageFile(null);
        history.push("/banner-management");
      } else {
        toast.error("Something went wrong while uploading the Banner.", {
          toastId: "uploadBanner",
        });
      }
    } catch (error) {
      console.error("Upload failed:", error);
      toast.error("An error occurred while uploading the Banner.");
    }
    setLoader(false);
  };

  const getSingleBanner = async () => {
    try {
      const response = await adminInstance().get(
        `/api/admin/getBannerById/${id}`
      );
      const { code, data: bannerData } = response?.data;
      if (code === 200 && bannerData) {
        setData({ title: bannerData.title });
        if (bannerData.image) {
          const imageUrlParts = bannerData.image.split("/");
          const fileWithExt = imageUrlParts[imageUrlParts.length - 1];
          const fileName = fileWithExt.split(".")[0];
          setImageFile({ name: fileName });
        }
      } else {
        toast.error("Failed to fetch video proof data");
      }
    } catch (error) {
      console.error("Error fetching video proof data:", error);
      toast.error("Error fetching video proof");
    }
  };

  useEffect(() => {
    if (id) {
      setLoader(true);
      getSingleBanner().then(() => setLoader(false));
    }
  }, [id]);

  return (
    <Fragment>
      <Breadcrumb title="Add Banner" />
      {laoder && <Loader />}
      <Container fluid={true}>
        <Card>
          <CardBody>
            <Form onSubmit={handleSubmit}>
              <FormGroup>
                <Label for="title">Title</Label>
                <Input
                  type="text"
                  id="title"
                  name="title"
                  value={data.title}
                  onChange={handleChange}
                  invalid={!!errors.title}
                />
                {errors.title && (
                  <small className="text-danger">{errors.title}</small>
                )}
              </FormGroup>

              <FormGroup className="justify-content-start">
                <div className="admin-input col-xl-10 col-md-7">
                  <Label className="col-form-label pt-0">
                    Image (1280 X 500)
                  </Label>
                  <div className="file-upload">
                    <div className="file-select file_select">
                      <div className="file-select-button">Choose File</div>
                      <div className="file-select-name">
                        {imageFile ? imageFile.name : "No file chosen..."}
                      </div>
                      <input
                        className="form-control"
                        type="file"
                        accept="image/*"
                        name="image"
                        onChange={handleChange}
                      />
                    </div>
                    {errors.image && (
                      <small className="text-danger">{errors.image}</small>
                    )}
                  </div>
                </div>
              </FormGroup>

              <Button disabled={laoder} type="submit" color="primary">
                {id
                  ? laoder
                    ? "Updating..."
                    : "Update"
                  : laoder
                  ? "Uploading..."
                  : "Upload"}
              </Button>
            </Form>
          </CardBody>
        </Card>
      </Container>
    </Fragment>
  );
};

export default CreateBanner;
